import React, {FC, useCallback, useEffect, useState} from 'react';
import {
    GxButton, GxForm,
    GxIcon, GxPhoneInput, GxSpinner,
} from '@garpix/garpix-web-components-react';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import {useStoreon} from 'storeon/react';
import {Modal} from 'react-responsive-modal';
import cnBind from 'classnames/bind';
import { api } from '@/api';
import styles from './styles/index.module.scss';
import 'react-responsive-modal/styles.css';
import {PhoneIcon} from '../../assets';
import FormError from '../FormError';
import {ATC_TYPE, validationSchemaModalPhoneCall} from '../../const';
import {getCookie} from '../../utils';

interface IModalPhoneCall {
    flag: boolean;
    onRequestClose: () => void;
}

const ModalPhoneCall: FC<IModalPhoneCall> = ({flag, onRequestClose}) => {
    const {infoCall} = useStoreon( 'infoCall');
    const {type, phone} = infoCall;

    const cn = cnBind.bind(styles);

    const [userInfo, setUserInfo] = useState<Record<string, any> | null>(null)
    const [loadFlag, setFlagLoad] = useState(false)
    const toggleSpinner = useCallback(() => setFlagLoad((prev) => !prev), [])

    const formik = useFormik({
        enableReinitialize: true,
        validationSchema: validationSchemaModalPhoneCall,
        validateOnChange: false,
        validateOnBlur: false,
        initialValues: {
            phone
        },
        onSubmit(values) {
            toggleSpinner();
            api.atc.atcApi({
                cmd: 'makeCall',
                phone: values.phone,
                user: getCookie('operatorAtcNumber') || ''
            }).catch(() => {
                toggleSpinner();
                toast.error('Ошибка создания звонка!');
            })
        }
    })

  useEffect(() => {
    if (phone && type !== 'DEFAULT') {
      api.user.getUsers({
        search: phone
      }).then(({ results }) => {
        setUserInfo(results.length > 0 ? results[0] : null)
      })
    }
  }, [type])

    return (
        <Modal
            open={flag}
            center
            onClose={onRequestClose}
            closeOnOverlayClick
            styles={{
                overlay:
                    {background: 'none'},
                modal: {
                    position: 'fixed',
                    right: 0,
                    top: '50px',
                    padding: 0,
                    marginRight: 5,
                    zIndex: 21,
                    width: '100%',
                    maxWidth: 490
                },
                root:{
                    position: 'inherit'
                }
            }}
        >
            <div className={cn({
                header: true,
                'header--incoming': type === 'INCOMING',
                'header--outgoing': type === 'OUTGOING',
                'header--accepted': type === 'ACCEPTED',

            })}
                 tabIndex={0}
                 role='button'
                 onKeyDown={(e) => {
                     if (e.key === 'Enter') {
                         formik.handleSubmit();
                     }
                 }}
            >
                <div className={styles['header--container']}>
                    <GxIcon className={styles['header--icon']} src={PhoneIcon}/>
                    <h2 className={styles['header--title']}>{ATC_TYPE[type]}</h2>
                </div>
            </div>
            <div className={styles['main']}>
                <GxForm onGx-submit={formik.submitForm} className={styles['form']}>
                    <div className={styles['container']}>
                        <label htmlFor="test" className={cn(styles['phone'], styles['phone--label'])}>
                            <span>Телефон:</span>
                            <GxPhoneInput
                                value={formik.values.phone}
                                onGx-change={(phone: any) => formik.setFieldValue('phone', `+${phone.detail.value}`)}
                                country='ru'
                                className={cn({
                                    'phone__input': true,
                                    'phone__input--incoming': type === 'INCOMING',
                                    'phone__input--outgoing': type === 'OUTGOING',
                                })}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        formik.handleSubmit();
                                    }
                                }}
                                disabled={type !== 'DEFAULT'}
                            />
                        </label>
                        {formik.errors.phone &&
                            <div className={styles['user--errors']} style={{position: 'absolute'}}>
                              <FormError text={formik.errors.phone}/>
                            </div>
                        }
                    </div>
                    {type === 'DEFAULT' && <GxButton className={styles['btn']} type='submit'>
                        {loadFlag ? <GxSpinner style={{fontSize: '1rem', '--stroke-width': '3px'}}/> : 'Позвонить'}
                    </GxButton>
                    }
                </GxForm>
                {type !== 'DEFAULT' &&
                <div className={styles['info']}>
                    {
                        userInfo ?
                            <>
                                <p className={styles['info--title']}>{`${userInfo.last_name} ${userInfo.first_name} ${userInfo.patronymic_name ? userInfo.patronymic_name : ''}`}</p>
                                <div className={styles['info--text']}>
                                    <p>
                                        <span>Труба:</span> {userInfo.tube_user_type.title}
                                    </p>
                                    <p>
                                        <span>Волна:</span> {userInfo.wave_user_type.title}
                                    </p>
                                </div>
                            </>
                            :
                            <p className={styles['info--title']}>
                                Неизвестный номер...
                            </p>
                    }
                </div>
                }
            </div>
        </Modal>
    );
};

export default ModalPhoneCall;